<template>
    <div class="form-editor scrollbar-custom">
        <div>
            <no-selected-model-comp
                :display="!schema.selectedModel"
                :read-only="readOnly"
                :selected-model="schema.selectedModel !== undefined"
            ></no-selected-model-comp>
            <fields-form
                v-if="schema.selectedModel"
                :key="schema.selectedModel.uid"
                :selected-model="schema.selectedModel"
                :schema="schema"
                :read-only="readOnly"
            >
            </fields-form>
        </div>
    </div>
</template>

<script>
import CreateBtn from '@/components/Partials/create-new-button.vue';
import FieldsForm from './fields-form.vue';
import NoSelectedModelComp from '../no-selected-model-composant.vue';
export default {

    components: {
        CreateBtn,
        FieldsForm,
        NoSelectedModelComp,
    },

    props: {
        schema: {
            type: Object,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        }
    },

    data (){
        return {
            editModel: false,
        };
    },

    computed: {
    },

    mounted (){
    },

    beforeDestroy (){
    },

    methods: {
    },
};
</script>

<style lang="scss">
.form-editor{
    position: relative;
    padding: 15px;
    width: 39%;
    background-color: #1D1F21;
    overflow-y: auto;
    height: calc(100vh - 160px); /* <- 160px = h de la toolbar principal + h de la barre des tabs + height de la toolbar d'actions sur les models */
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/index.vue